<template>
  <nav class="navbar">
    <div class="container">
      <router-link to="/" class="logo">
        <span>浪狐科技</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup>

</script>

<style scoped>
.navbar {
  background-color: var(--primary-color);
  color: var(--text-light);
  padding: 1rem 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  color: var(--text-light);
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
}

.nav-links {
  #display: flex;
  display: none;
  gap: 2rem;
}

.nav-links a {
  color: var(--text-light);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
  padding: 0.5rem 0;
  position: relative;
}

.nav-links a:hover {
  color: #cccccc;
}

.nav-links a.router-link-exact-active {
  color: #ffffff;
  font-weight: bold;
}

.nav-links a.router-link-exact-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #ffffff;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  height: 20px;
  width: 30px;
  padding: 0;
}

.menu-toggle span {
  display: block;
  width: 100%;
  height: 3px;
  background-color: var(--text-light);
  transition: all 0.3s;
}

@media (max-width: 768px) {
  .nav-links {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    background-color: var(--primary-color);
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1rem 0;
    clip-path: circle(0px at 90% -10%);
    transition: clip-path 0.5s ease-in-out;
    z-index: 1000;
  }
  
  .nav-links.active {
    clip-path: circle(1000px at 90% -10%);
  }
  
  .menu-toggle {
    display: flex;
  }
}
</style>